(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/controllers/betslip.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/controllers/betslip.js'); (function(Backbone, _, svs) {
  'use strict';


  svs.isBetslipLoaded = false;

  svs.tipset.controllers.Betslip = function(options) {
    var log = new svs.core.log.Logger('svs.tipset.controllers.Betslip');

    return {
      options: options,
      storeState: {
        type: '',
        product: svs.tipset.models.gameDefinitions.get('productName'),
        validOpenState: options.model && options.model.get('isPayable')
      },
      relativeLayout: svs.core.detect.feature('ft-betslip'),

      initRelativeBetslip: function() {
        var self = this;
        this.scrollContent = svs.core.detect.formfactor.mobile()
          ? $('#main-content')
          : $('#coupon');
        if (!svs.core.detect.formfactor.mobile()) {
          this.swiperContainer = $('.js-swiper-container');
        }
        this.betslipWrapper = $('#betslip-wrapper');
        this.betslipPosition = $('.betslip-position-tag');
        this.actionbar = $('#action-wrapper');
        this.betslipFooter = $('#betslip-footer');

        if (!svs.tipset.models.play.get('isSingleRow')) {
          if (!svs.core.detect.formfactor.mobile()) {
            this.betslipWrapper.width(this.scrollContent[0].clientWidth);
          }
          this.actionbar.width(this.scrollContent[0].clientWidth);

          if (!svs.core.detect.formfactor.mobile()) {
            $(window).on('resize', function() {
              self.betslipWrapper.width(self.scrollContent[0].clientWidth);
              self.actionbar.width(self.scrollContent[0].clientWidth);
            });
          }
        }

        this.betslipFooter.off('click', _.bind(this.scrollToBetslip, this));
        this.betslipFooter.on('click', _.bind(this.scrollToBetslip, this));
        this.tipsetOverviewToogle = true;

        svs.tipset.models.betslipExpanded.setAccountListener();
      },

      scrollToBetslip: function(e) {
        e.preventDefault();
        var scrollToBetslip = this.scrollContent.height();
        if (svs.core.detect.formfactor.mobile()) {
          $('html, body')
            .stop()
            .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
        } else {
          $(this.swiperContainer)
            .has('#coupon')
            .stop()
            .animate({ scrollTop: scrollToBetslip }, 400, 'swing');
        }
      },

      additionalScrollHeight: function() {
        this.scrollContentHeight = this.scrollContent.height();
        this.betslipOffsetTop = svs.core.detect.formfactor.mobile()
          ? this.betslipPosition.offset().top
          : this.scrollContentHeight;
      },

      openBetslip: function(betslip) {
        if (!svs.core.detect.feature('ft-betslip')) {
          log.debug('betslip.openBetslip');
          svs.tipset.models.betslipExpanded.setAccountListener();
          svs.tipset.views.betslipExpanded = new svs.tipset.views.BetslipExpanded(
            {
              model: svs.tipset.models.betslipExpanded
            }
          );
          betslip
            .getRegion('betslipContent')
            .show(svs.tipset.views.betslipExpanded);
          betslip.getRegion('betslipFooter').show(
            new svs.tipset.views.PayFooter({
              model: svs.tipset.models.betslipFooter
            })
          );
          svs.tipset.views.betslip.betslipIsOpen = true;
        }
      },

      showOverview: function() {
        var betslipOverview = new svs.tipset.views.BetslipOverview({
          model: svs.tipset.models.betslipExpanded
        }).render().$el;

        if (
          svs.core.detect.formfactor.mobile() ||
          svs.tipset.models.play.get('isSingleRow')
        ) {
          svs.components.Modal.show(betslipOverview, null, {
            title: 'Översikt av spelet',
            headerClass: 'header-' + svs.tipset.data.gameDefinitions.htmlClass,
            dontPushModalToHistory: true,
            modalHistory: true,
            leftButton: {
              text: 'Stäng',
              visible: true,
              cssClass: 'btn-transparent-inverted',
              callback: function() {
                svs.components.Modal.hide();
                svs.tipset.views.betslip.betslipIsOpen = false;
                $(svs.components.Modal.getContentElement())
                  .find('.betslip-expanded')
                  .remove();
                betslipOverview = undefined;
                svs.tipset.views.betslipSliderFolder = undefined;
                return false;
              }
            },
            rightButton: {
              visible: false
            }
          });
        } else {
          var tipsetSliderFolder = $('.tipset-slider-folder');
          var tipsetSliderFolderDimmer = $('.tipset-betslipoverview-dimmer');
          tipsetSliderFolder.html(betslipOverview);

          if (this.tipsetOverviewToogle) {
            tipsetSliderFolder.removeClass('no-transition');
            tipsetSliderFolderDimmer.removeClass('no-transition');
          } else {
            tipsetSliderFolder.addClass('no-transition');
            tipsetSliderFolderDimmer.addClass('no-transition');
          }
          svs.tipset.models.betslipExpanded.toggleOverviewOpen();
          tipsetSliderFolder.toggleClass('tipset-slider-folder-open');
          tipsetSliderFolderDimmer.toggleClass('tipset-betslipoverview-dimmer-visible');
        }
        svs.tipset.views.betslip.betslipIsOpen = true;
      },
      closeBetslip: function(betslip) {
        if (svs.tipset.models.play.get('isSingleRow')) {
          betslip.getRegion('betslipFooter').show(
            new svs.tipset.views.BetslipFooterSinglerows({
              model: svs.tipset.models.betslipFooter
            })
          );
        } else {
          betslip.getRegion('betslipFooter').show(
            new svs.tipset.views.BetslipFooter({
              model: svs.tipset.models.betslipFooter
            })
          );
        }
        betslip.getRegion('betslipContent').empty();
        if (svs.tipset.views.betslipExpanded) {
          svs.tipset.views.betslipExpanded = undefined;
        }
        svs.tipset.views.betslip.betslipIsOpen = false;
      },

      collapseBetslip: function(betslip) {
        log.debug('betslip.collapseBetslip');
        betslip.$el.removeClass('open');
        betslip.$el.find('#betslip-footer').empty();
        $(betslip.regions.betslipContent).css('height', 0);
        betslip.getRegion('betslipContent').destroy();
        betslip.getRegion('betslipFooter').destroy();
        betslip.getRegion('betslipContent').empty();
        if (svs.tipset.views.betslipExpanded) {
          svs.tipset.views.betslipExpanded = undefined;
        }
        svs.tipset.views.betslip.betslipIsOpen = false;
      }
    };
  };
})(Backbone, _, svs);

 })(window);